import { render, staticRenderFns } from "./PlaySnake.vue?vue&type=template&id=2d033043&"
import script from "./PlaySnake.vue?vue&type=script&lang=js&"
export * from "./PlaySnake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports